var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-footer",
    {
      staticClass: "footer pt-2 primary",
      attrs: {
        id: "footer",
        padless: "",
        block: "",
        primary: "",
        role: "contentinfo",
      },
    },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "", sm12: "", md12: "", lg12: "", column: "" } },
        [
          _c(
            "v-card",
            {
              staticClass: "footer-card",
              attrs: { elevation: 0, secondary: "" },
            },
            [
              _c(
                "v-card-title",
                {
                  staticClass: "accent d-flex align-center",
                  attrs: { role: "heading", "aria-level": "2" },
                },
                [
                  _c("h2", { staticClass: "accent d-flex align-center" }, [
                    _c(
                      "strong",
                      { staticClass: "subheading text-subtitle-1" },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              "Follow our social media, we will keep you updated"
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      attrs: {
                        role: "group",
                        "aria-label": "Social media links",
                      },
                    },
                    _vm._l(_vm.communities, function (community) {
                      return _c(
                        "v-btn",
                        {
                          key: community.id,
                          staticClass: "mx-4",
                          attrs: {
                            dark: "",
                            icon: "",
                            "aria-label":
                              "Open " + community.name + " in new tab",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.goTo(community.link)
                            },
                          },
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                size: "24px",
                                title: community.name,
                                "aria-hidden": "true",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(community.icon) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider", { attrs: { "aria-hidden": "true" } }),
              _vm._v(" "),
              _c(
                "v-card-text",
                {
                  staticClass: "py-2 white--text text-center",
                  attrs: { "aria-label": "Copyright Notice" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(new Date().getFullYear()) +
                      " —\n        "
                  ),
                  _c("strong", [_vm._v("RedArc Studio Ltd")]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }